import script from "./object_course.vue?vue&type=script&setup=true&lang=js"
export * from "./object_course.vue?vue&type=script&setup=true&lang=js"

import "./object_course.vue?vue&type=style&index=0&id=29d2746e&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29d2746e"]])

export default __exports__